import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LENS_TYPES } from 'src/app/helpers/lenses.helper';
import { Employee } from 'src/app/models/employee.model';
import { CompanyLensTypeVM } from 'src/app/models/view-models/company-lens-type-vm.model';
import { CompanyLensesHelperService } from 'src/app/services/local/company-lenses-helper.service';
import { OrderManagerService } from 'src/app/services/local/order-manager.service';
import { EmployeeService } from 'src/app/services/repositories/employees.service';
import { GuidedOptModalComponent } from 'src/app/ui-widgets/guided-opt-modal/guided-opt-modal.component';

@Component({
    selector: 'app-lens-prescription',
    templateUrl: './lens-prescription.component.html',
    styleUrls: ['./lens-prescription.component.scss'],
    standalone: false
})
export class LensPrescriptionComponent implements OnInit {
  private employee: Employee | undefined;
  private queryParams: {} = {};
  public LENS_TYPES = LENS_TYPES;
  public isEditMode: boolean = false;
  public toggleClass: boolean = true;
  public isSingleVisionRecommended: boolean = false;
  public companyLensTypeVM: CompanyLensTypeVM | undefined;

  constructor(private _route: ActivatedRoute,
              private _router: Router,
              public _orderManagerService: OrderManagerService,
              private _modal: NgbModal,
              private _employeeService: EmployeeService,
              private _companyLensesHelperService: CompanyLensesHelperService) { }

  ngOnInit(): void {
    this._route.queryParams
    .subscribe(params => {
      this.isEditMode = params.isEditMode === 'true';
      this.queryParams = this.isEditMode ? {'isEditMode' : this.isEditMode} : {};
      this.getEmployeeInfo();
      this.loadLenses();
    });
   }

  loadLenses() {
    this._companyLensesHelperService.getAllLenses()
    .subscribe((data: any) => {
      if (data) {
        this.companyLensTypeVM = data;
      }
    }, (error: any) => {
      
    });
  }

  getEmployeeInfo() {
    this._employeeService.getEmployeeInfo()
    .subscribe((data: Employee) => {
      this.employee = data;
      this.setRecommendationFlag();
    }, (error: any) => {
      console.log(error);
    });
  }

  setRecommendationFlag() {
    const age = this.calculateAge();
    if (age) {
      if (age <= 40) {
        this.isSingleVisionRecommended = true;
      }
      else {
        this.isSingleVisionRecommended = false;
      }
    }
  }

  calculateAge(): number | undefined {
    if (this.employee?.dateOfBirth) {
      const bdate = new Date(this.employee?.dateOfBirth);
      const timeDiff = Math.abs(Date.now() - bdate.getTime());
      return Math.floor((timeDiff / (1000 * 3600 * 24)) / 365);
    }
    return undefined;
  }
   
  showGuidedOpticianModal(lensType: LENS_TYPES) {
    if (!this.isEditMode) {
      const guidedOpModal = this._modal.open(GuidedOptModalComponent,
        { size: 'lg', backdrop: 'static' });
        guidedOpModal.componentInstance.lenses = this.companyLensTypeVM?.prescriptionLenses;
        guidedOpModal.componentInstance.lensType = lensType;
        guidedOpModal.componentInstance.isSingleVisionRecommended = this.isSingleVisionRecommended;
    } 
    else {
      if (lensType == LENS_TYPES.singleVision) {
        this._router.navigate(['/lens-selection/prescription/single-vision'], { queryParams: this.queryParams });
      } else {
        this._router.navigate(['/lens-selection/prescription/bifocal-progressive'], { queryParams: this.queryParams });
      }
    }
  }

}
